import 'remixicon/fonts/remixicon.css';
import { Link, Route, Switch, useRouteMatch } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../store/Hooks';
import { Task } from '../../store/viewmodels/TaskViewModel';
import StudentResultInfo from './results/StudentResultInfo';
import React from 'react';
import { newAsLoaded } from '../../store/AnswerSetSlice';
import { StudentData } from '../../store/viewmodels/StudentViewModel';
import { fetchResults } from '../../store/StudentSlice';

function StudentResults() {
    let { path } = useRouteMatch();
    const dispatch = useAppDispatch();
    const studentData: StudentData = useAppSelector(state => state.studentData);
    const newAsToLoad: boolean | undefined = useAppSelector(state => state.answerSet.new);

    React.useEffect(() => {
        if (newAsToLoad) {
            dispatch(fetchResults(studentData.student.id))
                .then(() => {
                    dispatch(newAsLoaded())
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const tasks: Task[] = studentData.student.task_access_list;

    return (
        <div className="border flex flex-grow w-full">
            <div className="border-r max-w-1/2">
                <ResultsTasksList tasks={tasks} path={path} />
            </div>
            <Switch>
                <Route path={`${path}/:taskId`}>
                    {<StudentResultInfo />}
                </Route>
            </Switch>
        </div>
    );
}

interface ResultsTasksListProps {
    tasks: Task[]
    path: string
}

function ResultsTasksList(props: ResultsTasksListProps): JSX.Element {

    let taskitems: JSX.Element[] = [];
    taskitems = props.tasks?.map(task => <ResultsTasksListItem key={"resultListItem" + task.id} task={task} path={props.path} />)

    return (
        <div className="bg-white">
            <ul className="divide-y divide-gray-200 border-b">
                {taskitems}
            </ul>
        </div>)
        ;
}

interface ResultsTasksListItemProps {
    task: Task
    path: string
}

function ResultsTasksListItem(props: ResultsTasksListItemProps): JSX.Element {

    return (
        <li>
            <Link to={props.path + "/" + props.task.id} className="block group hover:bg-teal-50">
                <div className="flex items-center px-1 py-1 sm:px-6">
                    <div className="min-w-0 flex-1 flex items-center">
                        <div className="flex-shrink-0">
                            <i className={"text-gray-700 group-hover:text-teal-500 text-3xl ri-star-s-line"}></i>
                        </div>
                        <div className="min-w-0 flex-1 px-4">
                            <p className="text-sm font-medium text-teal-600 truncate">{props.task.name}</p>
                            <p className="text-sm font-medium text-teal-600 truncate">{ }</p>
                        </div>
                    </div>
                </div>
            </Link>
        </li>
    );
}

export default StudentResults;